
















































import { Component, Prop, Vue } from 'vue-property-decorator'
import searcherry from '@/services/Searcherry/Searcherry'
import { ExitWithProductEventData } from '@/services/Statistic/PostData'
import searcherryConfig from '@/services/Searcherry/SearcherryConfig'

@Component({
  name: 'product-item'
})
export default class ProductItem extends Vue {
  @Prop() product: any

  showProductSku = searcherryConfig.showProductSku
  badgeDiscountMode = searcherryConfig.badgeDiscountMode

  clickProduct (product: any, event: any) {
    // todo все проверить и довести до ума
    //    var e = event || window.event
    //    var btnCode
    //    if (typeof e === 'object') {
    //      btnCode = e.button
    //      switch (btnCode) {
    //        case 0:
    //          console.log('Нажата левая кнопка.')
    //          break
    //
    //        case 1:
    //          console.log('Нажата средняя кнопка или колёсико.')
    //          break
    //
    //        case 2:
    //          console.log('Нажата правая кнопка.')
    //          break
    //
    //        default:
    //          console.log('Неопределённое событие: ' + btnCode)
    //      }
    //    }
    let data = new ExitWithProductEventData()
    data.productName = product.name
    data.productUrl = product.url
    data.searchPhrase = this.$route.params.searchPhrase
    searcherry.statisticService.exitWithProductEvent(data)
    searcherry.generateEvent('exit-product')
  }
}
